import React from 'react';

import clsx from 'clsx';

import * as classes from './Block.module.css';

const ListBlock = ({
    id,
    type,
    number,
    list,
    ...props
}) => {

    return (
        <span data-type={type} style={{ display: 'flex', alignItems: 'center' }} id={`${id}-list-block`}>
            <React.Fragment>&nbsp;</React.Fragment>
            <div
                data-allow-insert={false}
                data-type={type}
                id={`${id}-list-block`}
                className={classes.Block}
            >
                <div
                    data-allow-insert={false}
                    data-type={type}
                    id="list-start"
                    className={classes.BlockBody}
                >
                    <span data-allow-insert={false}>{type}</span>
                    {
                        [...Array(number)].map((x, i) => {
                            if ((i + 1) === number) {
                                return (
                                    <span id={`listItem-${i}`} style={{ display: 'flex', alignItems: 'center' }}>(  )</span>
                                );
                            } else {
                                return (
                                    <span id={`listItem-${i}`} style={{ display: 'flex', alignItems: 'center' }}>(  )<div id={'comma'}>,</div> </span>
                                );
                            }
                        })
                    }
                </div>
                <div data-type={type} id="list-end" />
                <span
                    data-allow-insert={false}
                    id={`${id}-delete`}
                    role="none"
                    class={clsx('material-icons-outlined', classes.DeleteIcon)}
                >
                    delete
                </span>
                <span
                    data-allow-insert={false}
                    id={`${id}-options`}
                    data-type={type}
                    role="none"
                    class={clsx('material-icons-outlined', classes.DeleteIcon)}
                >
                    settings
                </span>
            </div>
            <React.Fragment>&nbsp;</React.Fragment>
        </span>
    );
};

export default ListBlock;
